import * as React from "react"

interface IProps {
  className?: string
}

const PressKitCoverFill = ({ className }: IProps) => {
  return (
    <svg
      width="612"
      height="792"
      viewBox="0 0 612 792"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#37EBC2" d="M0 0h612v792H0z" />
        <path
          d="M159.647 515c17.186 0 31.018-12.594 31.018-37.78v-1.12c0-25.046-13.832-37.92-30.879-37.92-11.039 0-18.584 5.878-22.775 12.874v-43.098H112V513.32h25.011v-11.334c3.633 7.836 11.736 13.014 22.636 13.014zm-8.804-19.17c-9.08 0-14.53-6.296-14.53-18.75v-1.12c0-12.313 5.45-18.889 14.53-18.889 8.804 0 14.393 6.156 14.393 19.03v1.119c0 12.034-5.03 18.61-14.393 18.61zM312.168 515c5.869 0 10.619-1.26 13.833-2.1v-19.03c-2.235.84-4.332 1.26-7.127 1.26-4.75 0-7.404-2.379-7.404-7.695v-30.224h14.391V440.14h-14.39v-15.252h-25.013v15.252h-8.802v17.07h8.802v32.604c0 17.21 9.222 25.186 25.71 25.186zm54.727 0c5.869 0 10.618-1.26 13.833-2.1v-19.03c-2.236.84-4.331 1.26-7.127 1.26-4.75 0-7.405-2.379-7.405-7.695v-30.224h14.392V440.14h-14.392v-15.252h-25.011v15.252h-8.802v17.07h8.802v32.604c0 17.21 9.223 25.186 25.71 25.186zm103.481-1.68h25.011v-34.7c0-11.755 8.382-16.513 23.613-16.092v-23.369c-11.317-.14-19.003 4.619-23.613 15.532V440.14h-25.011v73.18zM425.475 515c22.075 0 34.79-9.376 37.026-25.888h-23.473c-.979 4.899-4.473 8.677-12.716 8.677-8.943 0-14.532-5.598-15.23-15.252h51.419v-6.576c0-26.306-17.186-37.78-37.167-37.78-22.076 0-39.542 14.832-39.542 38.339v1.12c0 23.927 16.767 37.36 39.683 37.36zm-14.114-46.595c1.259-8.816 6.43-13.714 13.973-13.714 8.105 0 12.435 4.898 12.854 13.714h-26.827zM236.301 515c22.075 0 34.792-9.376 37.027-25.888h-23.474c-.978 4.899-4.472 8.677-12.715 8.677-8.943 0-14.533-5.598-15.23-15.252h51.419v-6.576c0-26.306-17.186-37.78-37.167-37.78-22.077 0-39.542 14.832-39.542 38.339v1.12c0 23.927 16.767 37.36 39.682 37.36zm-14.113-46.595c1.258-8.816 6.428-13.714 13.973-13.714 8.104 0 12.435 4.898 12.854 13.714h-26.827zm7.14-103.759l56.13 31.087.019-77.482-56.149-32.523v78.918zM169.471 249l61.305 28.272-57.664 40.977-.019 77.484-61.081-28.638V290.29L169.47 249z"
          fill="#291842"
        />
      </g>
    </svg>
  )
}

export default PressKitCoverFill
